import React, { useEffect, useState } from "react";
import { startCase, camelCase } from "lodash";
import QueryString from "query-string";
import config from "../../../config";
import { useSelector } from "react-redux";
import { useCountry, useCurrency } from "../../../provider/courtryProvider";
import { useLocation } from "react-router-dom";
import Table from "../../table";
import { capitalize } from "lodash";

const VendorBillHistory = (props) => {
  const [billId, setBillId] = useState("");
  const [vendorDetails, setVendorDetails] = useState({});
  const [vendorBillDetails, setVendorBillsDetails] = useState({});
  const customTaxType = useSelector((state) => state.shopDetails.customTaxType);
  const taxList = useSelector((state) => state.taxList.taxList);
  const [isLoading, setIsLoading] = useState(true);
  const currencyFormatter = useCurrency();
  const country = useCountry();
  const location = useLocation();
  const [tableColumns, setTableColumns] = useState([
    {
      title: "Product Name",
      render: (data) => {
        return (
          <>
            <h6>{startCase(camelCase(data.productName))}</h6>
            <p>{data?.unitOfMeasurment}</p>
          </>
        );
      },
    },
    {
      title: `Product Mrp(${country.CurrencySymbol})`,
      dataIndex: "productMrp",
      render: (data) => {
        return <p>{data ? data : "-"}</p>;
      },
    },
    {
      title: `Purchase Price(${country.CurrencySymbol})`,
      dataIndex: "purchasePrice",
    },
    {
      title: `Product Price(${country.CurrencySymbol})`,
      dataIndex: "productPrice",
    },
    {
      title: "Quantity",
      dataIndex: "count",
    },
    {
      title: "Returned Quantity",
      dataIndex: "returned",
      render: (data) => {
        return <span>{data ? data : "-"}</span>;
      },
    },
    {
      title: "Tax(%)",

      render: (data) => {
        return (
          <div>
            {data.taxId ? (
              <>
                <div>{getTax(data.taxId)?.taxName}</div>
              </>
            ) : (
              <p>{data.productTax ? data.productTax : "-"}</p>
            )}
          </div>
        );
      },
    },
    {
      title: "Inclusive/Exclusive",
      render: (data) => {
        return (
          <span>
            {data?.taxIncExc ? startCase(camelCase(data?.taxIncExc)) : "-"}
          </span>
        );
      },
    },
    {
      title: "Tax Type",
      render: (data) => {
        return (
          <div>
            {data?.taxId ? (
              <span>
                {data.taxType.map((taxType, index) => {
                  const label =
                    customTaxType.find(
                      (customTax) => customTax.taxId === taxType
                    )?.label || taxType;
                  return <span key={index}>{capitalize(label)}</span>;
                })}
              </span>
            ) : (
              <span>
                {data?.productTaxType
                  ? startCase(camelCase(data?.productTaxType))
                  : "-"}
              </span>
            )}
          </div>
        );
      },
    },
    {
      title: `SGST(${country.CurrencySymbol})`,
      field: "sgst",
      render: (data) => {
        return <span>{currencyFormatter(data.sgst)}</span>;
      },
    },
    {
      title: `CGST(${country.CurrencySymbol})`,
      field: "cgst",
      render: (data) => {
        return <span>{currencyFormatter(data.cgst)}</span>;
      },
    },
    {
      title: `IGST(${country.CurrencySymbol})`,
      field: "igst",
      render: (data) => {
        return <span>{currencyFormatter(data.igst)}</span>;
      },
    },
    {
      title: `CESS(${country.CurrencySymbol})`,
      field: "cess",
      render: (data) => {
        return <span>{currencyFormatter(data.cess)}</span>;
      },
    },
    {
      title: `Additional Cess(${country.CurrencySymbol})`,
      field: "additionalcess",
      render: (data) => {
        return <span>{currencyFormatter(data.additionalcess)}</span>;
      },
    },
    {
      title: `Total Price(${country.CurrencySymbol})`,
      field: "totalPrice",
      render: (data) => {
        return <span>{currencyFormatter(data.totalPrice)}</span>;
      },
    },
  ]);

  const [items, setItems] = useState([]);
  useEffect(() => {
    let params = QueryString.parse(location.search);
    fetchVendorBillDetails(params.id);
    setBillId(params.id);
  }, []);

  const fetchVendorBillDetails = async (billId) => {
    var res = await fetch(
      `${config.newApiGateway}/vendor/fetchVendorBillDetails`,
      {
        method: "POST",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ billId: billId }),
      }
    );
    res = await res.json();
    if (res.code === "ERROR") {
      return alert(res.message);
    }
    setIsLoading(false);
    setItems(res.data.vendorBillDetails.items);
    setVendorBillsDetails(res.data.vendorBillDetails);
    setVendorDetails(res.data?.vendorData);
  };

  console.log("taxList", taxList);

  const getTax = (id) => {
    const result = taxList.find((tax) => tax.taxId === id);
    return result;
  };

  useEffect(() => {
    if (customTaxType.length > 0) {
      const customTaxTypeColumns = customTaxType.map((i) => {
        return {
          title: i.label,
          dataIndex: i.label,
          render: (label) => {
            return (
              <div>
                <span>{label ? currencyFormatter(label) : "Nil"}</span>
              </div>
            );
          },
        };
      });
      const tempColumns = [...tableColumns];
      tempColumns.splice(13, 0, ...customTaxTypeColumns);
      setTableColumns(tempColumns);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customTaxType]);

  return (
    <>
      <div>
        <Table
          columns={tableColumns}
          title="Bills"
          data={items}
          style={{
            minHeight: "calc(100vh - 265px)",
          }}
          emptyContainerStyle={{
            minHeight: "calc(100vh - 300px)",
          }}
          loading={isLoading}
        />
      </div>
    </>
  );
};

export default VendorBillHistory;
